import { Bone, Stethoscope, Brain, HeartHandshake, Apple, PersonStanding, HeartPulse, Droplets, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { WA_SCHEDULE } from "@/lib/constants";

const SPECIALTIES = [
  {
    icon: Bone,
    title: "Ortopedia",
    text: "Atendimento especializado para avaliação e acompanhamento de condições relacionadas ao sistema musculoesquelético.",
  },
  {
    icon: Stethoscope,
    title: "Clínica Médica",
    text: "Avaliação e acompanhamento da sua saúde, com atenção às necessidades de cada paciente.",
  },
  {
    icon: Brain,
    title: "Psiquiatria",
    text: "Cuidado especializado com a saúde mental, com escuta e acompanhamento profissional.",
  },
  {
    icon: HeartHandshake,
    title: "Psicologia",
    text: "Apoio e acompanhamento para o seu bem-estar emocional e qualidade de vida.",
  },
  {
    icon: Apple,
    title: "Nutricionista",
    text: "Orientação nutricional para mais saúde, energia e equilíbrio no dia a dia.",
  },
  {
    icon: PersonStanding,
    title: "Pilates",
    text: "Exercícios guiados para fortalecimento, postura e consciência corporal.",
  },
  {
    icon: HeartPulse,
    title: "Fisioterapia",
    text: "Tratamentos voltados à recuperação de movimentos, funcionalidade e qualidade de vida.",
  },
  {
    icon: Droplets,
    title: "Drenagem Linfática",
    text: "Técnica que auxilia a circulação e contribui para o bem-estar do corpo.",
  },
];

export const Specialties = () => (
  <section id="especialidades" data-testid="specialties-section" className="bg-cob-beige/50 py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <SectionHeading
          overline="Modalidades de atendimento"
          title="Cuidado completo para cada necessidade"
          text="Áreas de atuação dedicadas à sua saúde, mobilidade e qualidade de vida."
        />
      </div>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SPECIALTIES.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.08} className="h-full">
            <div
              data-testid={`specialty-card-${item.title.toLowerCase().replace(/\s/g, "-")}`}
              className="group relative flex h-full flex-col rounded-2xl border-t-2 border-cob-gold/50 bg-white p-7 shadow-[0_10px_35px_-20px_rgba(6,63,50,0.2)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_28px_50px_-22px_rgba(6,63,50,0.35)]"
            >
              <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-cob-light/60 text-cob-dark transition-all duration-500 group-hover:bg-cob-dark group-hover:text-cob-gold group-hover:-rotate-6 group-hover:scale-105">
                <item.icon className="h-6 w-6" strokeWidth={1.6} />
              </div>
              <h3 className="mt-6 font-serif text-2xl font-semibold text-cob-dark">{item.title}</h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-cob-muted">{item.text}</p>
              <a
                href={WA_SCHEDULE}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`specialty-cta-${i + 1}`}
                className="mt-6 inline-flex items-center gap-1.5 text-[13px] font-semibold text-cob-green transition-colors hover:text-cob-dark"
              >
                Agendar avaliação
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
